// src/creator/creatorApi.ts
import { apiClient } from "@maat/api-base";
var creatorApi = {
  /** Links, rollups and recent activity in one read. */
  overview: async (params) => {
    return apiClient.get("/main/api/creator/overview", { params });
  },
  /** Mint a link for a channel. The code and the offer are not the creator's to pick. */
  createLink: async (data) => {
    return apiClient.post("/main/api/creator/links", data);
  },
  linkQr: async (linkId) => {
    return apiClient.get(`/main/api/creator/links/${linkId}/qr`);
  },
  /** The creator's whole funnel by day — the Overview chart. */
  timeseries: async (params) => {
    return apiClient.get("/main/api/creator/timeseries", { params });
  },
  /** One link's daily funnel — the chart on the per-link analytics page. */
  linkTimeseries: async (linkId, params) => {
    return apiClient.get(`/main/api/creator/links/${linkId}/timeseries`, { params });
  },
  /** What one link converted — paged, newest first. */
  linkConversions: async (linkId, params) => {
    return apiClient.get(`/main/api/creator/links/${linkId}/conversions`, { params });
  }
};

export {
  creatorApi
};
